import { CHANGE_LANGUAGE, SET_NOTIFICATIONS } from "../actions/actionTypes";

export default function (
  state = { currentUser: {}, language: "en_GB", notifications: [] },
  action
) {
  switch (action.type) {
    case "SET_USER":
    case "EDIT_USER":
      return Object.assign({}, state, {
        currentUser: action.currentUser,
      });
    case CHANGE_LANGUAGE:
      return Object.assign({}, state, {
        language: action.language,
      });
    case SET_NOTIFICATIONS:
      return Object.assign({}, state, {
        notifications: action.notifications,
      });
    default:
      return state;
  }
}
